<template functional>
  <div class="relative">
    <div class="footer-container flex justify-center items-center">
      <img
        class="logo"
        src="../../assets/cmacc_logo.png"
        alt=""
      />
      <!-- <p class="powered-text">Powered by House of Dev Technology</p> -->
      <p class="powered-text">Copyright &copy; 2021 House of Dev Technology Co., Ltd. All rights reserved.</p>
      <!-- <img
        class="logo"
        src="https://houseofdev.tech/assets/logo/house-of-dev-2.svg"
        alt=""
      /> -->
    </div>
    <!-- <footer class="the-footer flex-wrap justify-between footer-container" :class="classes">
    </footer> -->
  </div>
</template>

<script>
export default {
  name: "the-footer",
  props: {
    classes: {
      type: String,
    },
  },
};
</script>

<style scoped>
.footer-container {
  height: 40px;
  position: fixed;
  z-index: 100000;
  /* background-color: black; */
  /* opacity: 0.5; */
  width: 100vw;
  bottom: 5px;
  left: 0;
}

.logo {
  height: 100%;
  padding: 5px;
}

.powered-text {
  font-size: 12px;
  margin-right: 20px;
  color: #72CBD2;
}
</style>
